import { IReciter } from '@/infrastructure/interfaces/i-reciter';
import { addDomainForImage } from '@/utils/helpers/add-domain-for-image';

export const addDomainForReciterImages = (reciter: IReciter) => {
  addDomainForImage(reciter.image);
  addDomainForImage(reciter.transparent_image);
  addDomainForImage(reciter.feature_cover);
  addDomainForImage(reciter.feature_wide_cover);
};
